import React from "react";

import { Map } from "immutable";
import { debounce } from "lodash";

import WebsocketClient, { GroupEmitter } from "~/lib/websocket";

export type FellowAttachmentRequest = (id: string) => Promise<FellowAttachment | undefined>;
export interface FellowAttachment {
	readonly id: string;
	readonly creator?: {
		readonly id: string;
		readonly email?: string;
		readonly firstName?: string;
		readonly fullName?: string;
		readonly image?: string;
	};
	readonly filename: string;
	readonly filetype: string;
	readonly size: number;
	readonly updatedAt: string;
	readonly url: string;
	readonly dimensions?: { width: number | undefined; height: number | undefined };
}
export interface AttachmentsBaseProps {
	groupId: string;
}
export interface AttachmentsBaseState {
	previewCache: Map<string, string>;
}

export abstract class AttachmentsBaseClass<
	P extends AttachmentsBaseProps,
	S extends AttachmentsBaseState,
> extends React.Component<P, S> {
	socket: GroupEmitter | null = null;

	componentDidMount() {
		const websocketClient = WebsocketClient.getInstance();
		this.socket = websocketClient.getOrJoinGroup(`attachments.${this.props.groupId.split("=").join("")}`, {
			contentId: this.props.groupId,
			...this.socketGroupMetadata(),
		});
		this.socket.on("message", this.onSocketMessage);
	}

	socketGroupMetadata(): { [k: string]: unknown } | undefined {
		return undefined;
	}

	componentWillUnmount() {
		this.socket?.off("message", this.onSocketMessage);
		this.socket?.close();
		this.socket = null;
	}

	onSocketMessage = (data: { type: string }) => {
		if (data.type === "REFRESH") {
			this.refresh();
		}
	};
	refresh = debounce(this._refresh, 1000);

	_refresh() {
		console.error(`Refresh not handled in ${this.constructor.name}`);
	}
}
